// @flow
import styled from 'styled-components';
import { below } from '../../../assets/css/media';
import { OneColumnLayout } from "../../../components";

export const JoinLeagueLayout = styled(OneColumnLayout)`
	margin: 30px auto;

	.search-form-wrapper {
		display: flex;
		justify-content: space-between;
		margin: 1em 0;

		form {
			width: 630px;
		}
		
		${below.desktop`
			margin: 1em 10px;
			form {
				width: 55%;
			}
			
			a {
				width: 45%;
				font-size: 10px;
			}
		`}
	}
`;

export default JoinLeagueLayout;


// WEBPACK FOOTER //
// ./src/pages/leagues/leaguesJoin/JoinLeagueLayout.js